import { styled } from 'styled-components';
import { device } from 'commons';

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  padding: 32px 48px 8px;
  overflow-y: auto;

  @media (max-width: ${device.tablet}px) {
    padding: 32px 28px 8px;
  }
`;

export const AnchorStyle = styled.a`
  display: flex;
  gap: 8px;
  text-decoration: underline;
  align-items: center;
  background-color: transparent;
  color: ${({ theme }) => theme.primary_300};
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  gap: 16px 18px;
  flex-wrap: wrap;
`;

export const DatePickerWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: space-between;
  align-items: center;

  .title-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .date-container {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    min-width: 340px;
  }
`;

export const ExportWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;
